import {create} from 'zustand';
import {OpenDrawerFilterStore} from './types';

const useOpenDrawerFilterStore = create<OpenDrawerFilterStore>(set => ({
	openDrawerState: false,
	setOpenDrawerState: value => set({openDrawerState: value}),
}));

export {useOpenDrawerFilterStore};
